import { EmojiItem } from '@tiptap/extension-emoji'

import { STROKE_COLOR_OPTIONS } from '@/pages/DocumentPage/components/Annotations/constants'
import { ntc } from '@/utils/nameThatColor'

export const HIGHLIGHT_COLORS = [
  { value: '#FFFFFF', name: 'White' },
  { value: '#E8E8E8', name: 'Gray' },
  { value: '#FFE4D6', name: 'Tan' },
  { value: '#FFD699', name: 'Orange' },
  { value: '#FFEB99', name: 'Yellow' },
  { value: '#D4F4DD', name: 'Green' },
  { value: '#CCE7FF', name: 'Blue' },
  { value: '#E6D9F2', name: 'Purple' },
  { value: '#FFD6E8', name: 'Pink' },
  { value: '#FFD1CC', name: 'Red' },
]

export const TEXT_COLORS = [
  { value: '#000000', name: 'Black' },
  { value: '#808080', name: 'Gray' },
  { value: '#8B4513', name: 'Brown' },
  { value: '#FF8C00', name: 'Orange' },
  { value: '#DAA520', name: 'Gold' },
  { value: '#228B22', name: 'Green' },
  { value: '#0066CC', name: 'Blue' },
  { value: '#7B3F9E', name: 'Purple' },
  { value: '#C71585', name: 'Magenta' },
  { value: '#CC0000', name: 'Red' },
]

const SHAPES_ICONS: Array<EmojiItem> = [
  {
    name: 'triangle',
    shortcodes: ['triangle'],
    tags: ['shapes', 'triangle'],
    group: 'shapes',
    emoticons: [],
    version: 1,
  },
  {
    name: 'square',
    shortcodes: ['square'],
    tags: ['shapes', 'square'],
    group: 'shapes',
    emoticons: [],
    version: 1,
  },
  {
    name: 'circle',
    shortcodes: ['circle'],
    tags: ['shapes', 'circle'],
    group: 'shapes',
    emoticons: [],
    version: 1,
  },
]

const HARDWARE_ICONS: Array<EmojiItem> = [
  {
    name: 'torx',
    shortcodes: ['torx'],
    tags: ['hardware', 'torx'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/torx.svg',
  },
  {
    name: 'phillips',
    shortcodes: ['phillips'],
    tags: ['hardware', 'phillips'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/phillips.svg',
  },
  {
    name: 'hex',
    shortcodes: ['hex'],
    tags: ['hardware', 'hex'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/hex.svg',
  },
  {
    name: 'pozidriv',
    shortcodes: ['pozidriv'],
    tags: ['hardware', 'pozidriv'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/pozidriv.svg',
  },
  {
    name: 'fire',
    shortcodes: ['fire'],
    tags: ['hardware', 'fire'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/fireHazard.svg',
  },
  {
    name: 'warning',
    shortcodes: ['warning'],
    tags: ['hardware', 'warning'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/warning.svg',
  },
  {
    name: 'W001-warning',
    shortcodes: ['W001-warning'],
    tags: ['hardware', 'W001-warning'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/ISO-warning.svg',
  },
  {
    name: 'W002-explosive',
    shortcodes: ['W002-explosive'],
    tags: ['hardware', 'W002-explosive'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/ISO-explosive.svg',
  },
  {
    name: 'W003-radioactive-ionizing-radiation',
    shortcodes: ['W003-radioactive-ionizing-radiation'],
    tags: ['hardware', 'W003-radioactive-ionizing-radiation'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/ISO-radioactive-ionizing-radiation.svg',
  },
  {
    name: 'W005-non-ionizing-radiation',
    shortcodes: ['W005-non-ionizing-radiation'],
    tags: ['hardware', 'W005-non-ionizing-radiation'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/ISO-nonionizing-radiation.svg',
  },
  {
    name: 'W007-floor-level-obstacle',
    shortcodes: ['W007-floor-level-obstacle'],
    tags: ['hardware', 'W007-floor-level-obstacle'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/ISO-floor-level-obstacle.svg',
  },
  {
    name: 'W011-slippy-surface',
    shortcodes: ['W011-slippy-surface'],
    tags: ['hardware', 'W011-slippy-surface'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/ISO-slippery-surface.svg',
  },
  {
    name: 'W012-electricity',
    shortcodes: ['W012-electricity'],
    tags: ['hardware', 'W012-electricity'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/ISO-electricity.svg',
  },
  {
    name: 'W014-forklift',
    shortcodes: ['W014-forklift'],
    tags: ['hardware', 'W014-forklift'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/ISO-forklift.svg',
  },
  {
    name: 'W015-overhead-load',
    shortcodes: ['W015-overhead-load'],
    tags: ['hardware', 'W015-overhead-load'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/ISO-overhead-load.svg',
  },
  {
    name: 'W021-flammable',
    shortcodes: ['W021-flammable'],
    tags: ['hardware', 'W021-flammable'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/ISO-flammable.svg',
  },
  {
    name: 'W022-sharp-object',
    shortcodes: ['W022-sharp-object'],
    tags: ['hardware', 'W022-sharp-object'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/ISO-sharp-object.svg',
  },
  {
    name: 'W087-loud-sounds',
    shortcodes: ['W087-loud-sounds'],
    tags: ['hardware', 'W087-loud-sounds'],
    group: 'hardware',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/ISO-loud-sounds.svg',
  },
]

const LETTER_ICONS: Array<EmojiItem> = [
  {
    emoji: 'Ⓐ',
    name: 'A',
    shortcodes: ['A', 'a'],
    tags: ['letters', 'A'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓑ',
    name: 'B',
    shortcodes: ['B', 'b'],
    tags: ['letters', 'B'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓒ',
    name: 'C',
    shortcodes: ['C', 'c'],
    tags: ['letters', 'C'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓓ',
    name: 'D',
    shortcodes: ['D', 'd'],
    tags: ['letters', 'D'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓔ',
    name: 'E',
    shortcodes: ['E', 'e'],
    tags: ['letters', 'E'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓕ',
    name: 'F',
    shortcodes: ['F', 'f'],
    tags: ['letters', 'F'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓖ',
    name: 'G',
    shortcodes: ['G', 'g'],
    tags: ['letters', 'G'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓗ',
    name: 'H',
    shortcodes: ['H', 'h'],
    tags: ['letters', 'H'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓘ',
    name: 'I',
    shortcodes: ['I', 'i'],
    tags: ['letters', 'I'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓙ',
    name: 'J',
    shortcodes: ['J', 'j'],
    tags: ['letters', 'J'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓚ',
    name: 'K',
    shortcodes: ['K', 'k'],
    tags: ['letters', 'K'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓛ',
    name: 'L',
    shortcodes: ['L', 'l'],
    tags: ['letters', 'L'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    name: 'M',
    shortcodes: ['M', 'm'],
    tags: ['letters', 'M'],
    group: 'letters',
    emoticons: [],
    version: 1,
    fallbackImage: '/static/icons/circled-m.svg',
  },
  {
    emoji: 'Ⓝ',
    name: 'N',
    shortcodes: ['N', 'n'],
    tags: ['letters', 'N'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓞ',
    name: 'O',
    shortcodes: ['O', 'o'],
    tags: ['letters', 'O'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓟ',
    name: 'P',
    shortcodes: ['P', 'p'],
    tags: ['letters', 'P'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓠ',
    name: 'Q',
    shortcodes: ['Q', 'q'],
    tags: ['letters', 'Q'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓡ',
    name: 'R',
    shortcodes: ['R', 'r'],
    tags: ['letters', 'R'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓢ',
    name: 'S',
    shortcodes: ['S', 's'],
    tags: ['letters', 'S'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓣ',
    name: 'T',
    shortcodes: ['T', 't'],
    tags: ['letters', 'T'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓤ',
    name: 'U',
    shortcodes: ['U', 'u'],
    tags: ['letters', 'U'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓥ',
    name: 'V',
    shortcodes: ['V', 'v'],
    tags: ['letters', 'V'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓦ',
    name: 'W',
    shortcodes: ['W', 'w'],
    tags: ['letters', 'W'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓧ',
    name: 'X',
    shortcodes: ['X', 'x'],
    tags: ['letters', 'X'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓨ',
    name: 'Y',
    shortcodes: ['Y', 'y'],
    tags: ['letters', 'Y'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
  {
    emoji: 'Ⓩ',
    name: 'Z',
    shortcodes: ['Z', 'z'],
    tags: ['letters', 'Z'],
    group: 'letters',
    emoticons: [],
    version: 1,
  },
]

export const CUSTOM_ICONS: Array<EmojiItem> = [
  ...STROKE_COLOR_OPTIONS.reduce((acc, color) => {
    SHAPES_ICONS.forEach((shape) => {
      const colorVariationName = ntc
        .name(color)[1]
        .toLowerCase()
        .replace(' ', '-')
      const updatedName = `${shape.name}-${colorVariationName}`
      acc.push({
        ...shape,
        fallbackImage: `/static/icons/${updatedName}.svg`,
        name: updatedName,
        tags: [...shape.tags, colorVariationName],
        shortcodes: [...shape.shortcodes, updatedName],
      })
    })
    return acc
  }, [] as Array<EmojiItem>),
  ...HARDWARE_ICONS,
  ...LETTER_ICONS,
]

export enum ExtensionsEnum {
  ICONS = 'ICONS',
  LINK = 'LINK',
  COLOR = 'COLOR',
  UNDERLINE = 'UNDERLINE',
  TEXT_ALIGN = 'TEXT_ALIGN',
  MARKER = 'MARKER',
  TOOL_NAME = 'TOOL_NAME',
  HIGHLIGHT = 'HIGHLIGHT',
  TASK_LIST = 'TASK_LIST',
  TASK_ITEM = 'TASK_ITEM',
  MENTION = 'MENTION',
  SLASH_COMMAND = 'SLASH_COMMAND',
  CHARACTER_COUNT = 'CHARACTER_COUNT',
  BACKGROUND = 'BACKGROUND',
}
